module.exports = function() {
  return new Worker(__webpack_public_path__ + "3bf5a6d5d519481c43f6.worker.js");
};